import { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Mail, Loader2, CheckCircle2 } from "lucide-react";

export default function NewsletterForm({ source = "website", variant = "inline", onDone }) {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const dark = variant === "footer";

  const submit = async (e) => {
    e.preventDefault();
    if (busy) return;
    setBusy(true);
    try {
      const r = await api.post("/public/newsletter/subscribe", { email, source });
      setDone(true);
      if (r.data.status === "confirmed") toast.success("Sie sind bereits angemeldet.");
      else toast.success("Fast geschafft – bitte bestätigen Sie den Link in Ihrer E-Mail.");
      onDone?.();
    } catch (e2) {
      toast.error(e2.response?.data?.detail || "Anmeldung fehlgeschlagen. Bitte erneut versuchen.");
    } finally { setBusy(false); }
  };

  if (done) return (
    <div className={`flex items-start gap-2 text-sm ${dark ? "text-white/75" : "text-fc-ink/70"}`} data-testid="newsletter-done">
      <CheckCircle2 className="w-5 h-5 text-fc-mint shrink-0 mt-0.5" />
      <span>Bitte bestätigen Sie Ihre Anmeldung über den Link, den wir Ihnen gerade per E-Mail gesendet haben.</span>
    </div>
  );

  return (
    <form onSubmit={submit} data-testid="newsletter-form" className="w-full">
      <div className="flex flex-col sm:flex-row gap-2">
        <div className="relative flex-1">
          <Mail className={`w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 ${dark ? "text-white/40" : "text-fc-ink/40"}`} />
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Ihre E-Mail-Adresse" data-testid="newsletter-email"
            className={`w-full rounded-xl pl-9 pr-3 h-11 text-sm outline-none border transition-colors ${dark ? "bg-white/10 border-white/15 text-white placeholder-white/40 focus:border-white/40" : "bg-white border-fc-border text-fc-ink focus:border-fc-blue"}`} />
        </div>
        <button type="submit" disabled={busy} data-testid="newsletter-submit"
          className="inline-flex items-center justify-center gap-1.5 rounded-xl bg-fc-blue text-white font-semibold px-5 h-11 text-sm hover:bg-fc-blue/90 transition-colors disabled:opacity-60 whitespace-nowrap">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : null} Updates erhalten
        </button>
      </div>
      <p className={`mt-2 text-xs ${dark ? "text-white/45" : "text-fc-ink/45"}`}>
        Sie können sich jederzeit wieder abmelden. Weitere Informationen finden Sie in unserer{" "}
        <a href="/datenschutz" className="underline hover:opacity-80">Datenschutzerklärung</a>.
      </p>
    </form>
  );
}
